import { medicalPatient, officeAsset, retailExhibition } from '@pages/Enterprise/Solution/components/Banner/BannerImages';
import productImg from '../main/product/productImg';
import productPurchase from '../main/product/productPurchase';
import video from '@src/assets/images/solution/manufacturingProcess/video/rtlsVideo.mp4';

export default {
  desc: 'Smart Hospital (Bệnh viện thông minh) tập trung vào việc nâng cao hiệu quả và chất lượng dịch vụ y tế bằng cách sử dụng IoT, Trí tuệ nhân tạo (AI) và phân tích dữ liệu để giám sát tình trạng sức khỏe của bệnh nhân theo thời gian thực, cải thiện quy trình chẩn đoán và điều trị.',
  keywords: 'Smart Hospital, Bệnh viện thông minh, Benh vien thong minh, Y tế thông minh, Y te thong minh, Digital Twin, Theo dõi vị trí, Theodoivitri\n',
  ogSite: 'Smart Hospital là gì?',
  title: 'Smart Hospital là gì?',
  ogUrl: 'https://orbro.io/vi/blog/스마트병원이란',
  ogImg:
    'https://lh3.googleusercontent.com/fife/AGXqzDmPfoc5xcFsetUID5pyg3CYD7YMozk7v8agtjsAU3FWSwMrSh5jezcJw00E2PsYdRwBciFQJKL4IguNdWivv4bRwDkwLuH_X_qAV982dYuBJho1obfwpVkXOoGGsFzUHcZ6I-tLD3CCDnlOljA-ZIojFjbigYAYMSdbWykA0SplErndN38ZvDJCDdtAJKIn703TEZAaikiyqmO_dZMOzge0_bIm3eS8eIPGsweG-xjhoDelT8CCOdyeN0LY68PSWfiinGf0eEuOoS3pti-1ZwLu-JjJELZsO1tsY30mxgenUNvpYfjBhCHq2IFN2vX5T-39NwhhLOOxM_5WE1ec46dO8qlMqV2Z1m6FkaFlsNr4fCccF3HM0uahwB1AlQY9T47hoqeH3C6kQC3JbanZWKV_CWqzXDVXLdEbwzA7taG3ny_gWknaCAdR_v0oqgaUnAkuOldeRH5wVEsZC6SaHP8T-DZXTyl_XTvlPl3WRE5POEcdCSelPI6gRWOzIuFOfyImIPGqtxPuc2yuwk9lv372FquiGhHqBAkHQ8FoPn5lNd7nVuV0COyXuu5vdL3sdii7rC-xZQ9s55QCRPlGbX51dJb6u-ku9H_Cv-Dxr-zr4PV0TnSKTWQxdM0kJbKL2kEgQCahORl-3ojZaHOXWE9Hqu5GjfKdar2oI2wNIGP82lEb7oRlXwEtqokSSFGY2SW6Sz-GeEUyJWL17f4XqGaBnv-bC_6XYXuyWQpnAU7VPOSjZOh4BPpQTAS1qEXKVISNMt9c4urPNVRAtG5I0Pn2v-fcBE4wcQgixYinbHP2OdtdyBKdjGOo31Zlp78Hs7PzDyWCQ4x8a4vV1z2EbrciEe2pcWWkll9qrFFYRRF62ecCzT9vRLko6dD4j9RjTWUigzS-Y0Un4NBy4gSwfIKmYvjf5q1muT96LYHPdE1qu-d9sUUW5Cg05eUAfUwwEFDQkms0x5jM5ds68-FYCiI2aeTY3nlo9E84to4h4o9Z2LjufbbwC3Y_zkPzkbREeF-FKbkRGiE1gw7WuUfRQ-K16n3rdiCytnsClNeTgIw_xYkkGYGS9TCh-BgPnvBvnvrfviZdwMpI22X-Jp_F4dVL_OBwVKMqKAUATJNPCcNiqqoGAHJdOv4Zwt4odCav4i7sM7_ZdJaN08S5egxFZMpLL9Lu1TR9SGWSpT-opyrkMUo2yWTKLtxY6E4mjO1EV5a2qRD-OSbGxlT6-HBn2HvJpvlbmHyChUDA1LR5aTDsReQq8lP5lIHjbkA1lD0h9x-MuYp0QUXJWiAoMdRxNVQBsZUHjkJP41fTk1bBuizb8U9tp3kv_NReX8fCs7a8UNYbGnWllcN3mRBSET80gDqirtQm2Nw5uX7nXHQvgKOqFufopQIHmjdVZBBRgLs9ofbVSgaD3bryP8l7mMotKmEyOPA_cD-WbTB8aSMfUbgqc_WSyW_3VJi_4Y0B2QfdwRGnr2d_lPXG_V62CHnP1vjPlkC7xGDXxVzG6hmC6EWsrfSEUvAywKLYdmBc0bEGQzj33GVTHADzLtZ01SU_juNo-ASh-i-A=w1834-h1208',
  ogType: 'website',
  date: '2024-01-16',
  tag1: '#SmartHospital',
  tag2: '#Benhvienthongminh',
  tag3: '#Ytethongminh',
  tag4: '#Theodoivitri',
  text: [
    {
      head: 'Smart Hospital là gì?',
      subHead: '',
      desc: 'Smart Hospital (Bệnh viện thông minh) tập trung vào việc nâng cao hiệu quả và chất lượng dịch vụ y tế bằng cách sử dụng IoT, Trí tuệ nhân tạo (AI) và phân tích dữ liệu để giám sát tình trạng sức khỏe của bệnh nhân theo thời gian thực, cải thiện quy trình chẩn đoán và điều trị. Smart Hospital hướng tới một hệ thống y tế đổi mới, cung cấp dịch vụ y tế nhanh chóng và hiệu quả, hỗ trợ việc chia sẻ thông tin y tế hiệu quả và ra quyết định. Thông qua đó, bệnh nhân có thể nhận được dịch vụ y tế tiện lợi và cá nhân hóa hơn.',
      dot: '',
    },
    {
      head: 'Các công nghệ ứng dụng trong Smart Hospital',
      subHead: '',
      desc: 'Smart Hospital sử dụng đa dạng công nghệ để cung cấp dịch vụ y tế hiện đại và hiệu quả. Các công nghệ chính bao gồm:',
      dot: '',
    },
    {
      head: '',
      subHead: 'Công nghệ Giám sát theo thời gian thực',
      desc: 'Giám sát tình trạng bệnh nhân theo thời gian thực giúp đội ngũ y tế phản ứng ngay lập tức và điều chỉnh điều trị. Điều này tăng cường an toàn và giám sát bệnh nhân.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Hồ sơ Y tế Điện tử (EMR)',
      desc: 'Ghi lại và quản lý điện tử hồ sơ y tế của bệnh nhân, giúp đội ngũ y tế truy cập thông tin và đưa ra quyết định hiệu quả.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Công nghệ Robot',
      desc: 'Robot được sử dụng trong nhiều công việc y tế khác nhau như hỗ trợ phẫu thuật, chăm sóc bệnh nhân, cung cấp thuốc, v.v., hỗ trợ nhân lực và nâng cao dịch vụ y tế tại Smart Hospital.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Công nghệ IoT (Internet vạn vật)',
      desc: 'Giám sát tình trạng sức khỏe của bệnh nhân theo thời gian thực và thu thập dữ liệu thông qua các thiết bị y tế và cảm biến. Thông qua đó, có thể cung cấp dịch vụ y tế cá nhân hóa.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Trí tuệ nhân tạo (AI) và Phân tích Big Data',
      desc: 'Sử dụng AI để phân tích dữ liệu y tế và phát triển các mô hình dự đoán, từ đó tăng cường chẩn đoán sớm và phòng ngừa bệnh, đồng thời giảm chi phí y tế.',
      dot: '',
    },
    {
      head: 'Ưu điểm của Smart Hospital',
      subHead: '',
      desc: 'Ưu điểm của Smart Hospital bao gồm quản lý hồ sơ y tế hiệu quả thông qua Hồ sơ Y tế Điện tử (EMR), phản ứng nhanh chóng và cung cấp điều trị kịp thời thông qua giám sát theo thời gian thực, tăng cường phòng ngừa bệnh và chẩn đoán sớm bằng cách sử dụng Trí tuệ nhân tạo (AI) và phân tích Big Data.\nNgoài ra, còn có các ưu điểm như quy trình đặt lịch hẹn và khám chữa bệnh tiện lợi nhằm cải thiện trải nghiệm bệnh nhân, việc áp dụng công nghệ IoT để cung cấp dịch vụ y tế cá nhân hóa, sử dụng thực tế ảo (VR) và thực tế tăng cường (AR) để giáo dục bệnh nhân và phục hồi chức năng hiệu quả, và hỗ trợ nhân lực y tế thông qua công nghệ robot. Sự hội tụ của các công nghệ này đang cách mạng hóa việc điều trị và cung cấp dịch vụ y tế tại Smart Hospital.',
      dot: '',
    },
    {
      head: 'Các trường hợp Smart Hospital điển hình',
      subHead: 'Mayo Clinic',
      desc: 'Mayo Clinic là một trong những Smart Hospital nổi tiếng toàn cầu, đang tích hợp Hồ sơ Y tế Điện tử (EMR) và hệ thống giám sát theo thời gian thực để tăng cường hiệu quả điều trị bệnh nhân. Ngoài ra, họ còn cung cấp cho bệnh nhân các chức năng đặt lịch hẹn và truy cập thông tin y tế qua ứng dụng di động.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Singapore General Hospital',
      desc: 'Bệnh viện Đa khoa Singapore đang tích cực sử dụng công nghệ thông minh để đổi mới dịch vụ y tế. Việc áp dụng giám sát theo thời gian thực, thiết bị IoT, phẫu thuật bằng robot, v.v., đã nâng cao hiệu quả điều trị bệnh nhân và cung cấp dịch vụ cá nhân hóa cho họ.',
      dot: '',
    },
    {
      head: '',
      subHead: 'Sheba Medical Center',
      desc: 'Sheba Medical Center đang tiếp cận đổi mới trong giáo dục và điều trị bệnh nhân bằng cách sử dụng thực tế ảo (VR). Các chương trình điều trị sử dụng VR đã đóng góp hiệu quả vào quá trình phục hồi chức năng của bệnh nhân.',
      dot: '',
    },
    {
      head: 'Triển vọng phát triển của Smart Hospital',
      subHead: '',
      desc: 'Smart Hospital đang trở thành một phần quan trọng của ngành y tế đang phát triển nhanh chóng. Bằng cách sử dụng các công nghệ tiên tiến và Trí tuệ nhân tạo (AI), việc chẩn đoán và điều trị bệnh nhân được tiến hành hiệu quả, đồng thời sự hợp tác giữa các bác sĩ được tăng cường thông qua việc chia sẻ dữ liệu y tế theo thời gian thực. Bệnh nhân có thể giám sát tình trạng sức khỏe của mình và dễ dàng truy cập dịch vụ y tế thông qua ứng dụng di động, mang lại sự tiện lợi. Ngoài ra, Smart Hospital quản lý chặt chẽ hồ sơ y tế cá nhân của bệnh nhân, nâng cao tính an toàn của thông tin y tế. Trong tương lai, với các công nghệ và dịch vụ đổi mới hơn nữa, Smart Hospital được dự đoán sẽ cung cấp một môi trường y tế lấy bệnh nhân làm trung tâm, hiệu quả và an toàn.',
      dot: '',
    },
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'Sản phẩm này giúp gắn thiết bị UWB lên nhân viên hoặc thiết bị, hỗ trợ theo dõi vị trí theo thời gian thực.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: medicalPatient.thumb,
        data: 'medicalPatient',
        link: '/vi/enterprise/medical/patient',
      },
      {
        img: retailExhibition.thumb,
        data: 'retailExhibition',
        link: '/vi/enterprise/retail/exhibition',
      },
      {
        img: officeAsset.thumb,
        data: 'officeAsset',
        link: '/vi/enterprise/office/asset',
      },
    ],
  },
};
